import React from 'react';
import SROChat from '../components/SROChat';

export default function SROChatPage() {
  return (
    <div className="p-4">
      <SROChat />
    </div>
  );
}